import { useTranslation } from 'react-i18next';
import { BalanceProjection } from '../../../../web/src/components/display/balance-projection.jsx';
import { useSiteLang } from '../../layout/use-site-lang.js';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { SchedulesCard } from '../schedules-card.jsx';

const PROJECTION = {
	en: { name: 'Royal Bank', before: 3850, after: 2610, dps: 2, symbol: '\u00A3' },
	'en-US': { name: 'Chase Checking', before: 4800, after: 3560, dps: 2, symbol: '$' },
	ja: { name: 'みどり銀行', before: 350000, after: 225000, dps: 0, symbol: '\u00A5' },
	ko: { name: '새봄은행', before: 3500000, after: 2250000, dps: 0, symbol: '\u20A9' },
	'zh-CN': { name: '常青银行', before: 26950, after: 18270, dps: 2, symbol: '\u00A5' },
	'zh-TW': { name: '常綠銀行', before: 115500, after: 78300, dps: 0, symbol: 'NT$' },
};

/**
 * Schedules use-case mockup: the credit-card payment schedule plus a live
 * balance projection rendered with the app's real BalanceProjection.
 * @returns {JSX.Element}
 */
export function SchedulesScreen() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const proj = PROJECTION[lang] ?? PROJECTION.en;
	return (
		<>
			<div className="use-case-callout use-case-projection card">
				<h3>{t('usecase.schedules.projection.title')}</h3>
				<p className="projection-line">
					<BalanceProjection name={proj.name} before={proj.before} after={proj.after} dps={proj.dps} symbol={proj.symbol} />
				</p>
				<p>{t('usecase.schedules.projection.body')}</p>
			</div>
			<MockAppFrame>
				<SchedulesCard />
			</MockAppFrame>
		</>
	);
}
